export default "__VITE_ASSET__BxpX5oHW__"